import React, { useState, useEffect } from "react";
import "../styles/table.css";
import {
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { listAllOffer, deleteOffer } from "../services/offerService";
import Loader from "../shared/components/Loader";
import { Sample } from "../assets/images";
import Pagination from "../shared/components/Pagination";
import { NoData } from "../assets/images/index";
import { toastMessage } from "../shared/components/Toast";
import { useLogoutHelper } from "../utils/helper";
import { ModeEdit, Delete, Visibility, Add } from "@mui/icons-material";
import ViewDetail from "./../shared/Modals/ViewDetails";
import Checkbox from "@mui/material/Checkbox";
import { useNavigate } from "react-router-dom";
import useDebounce from "../hooks/debounce";
import useMediaQuery from "@mui/material/useMediaQuery";
import ResponsiveEntityCard from "../shared/components/ResponsiveEntityCard";
export default function Offer() {
  const isCompactLayout = useMediaQuery("(max-width:1024px)");
  let types = {
    single: "single",
    multiple: "multiple",
  };
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [loader, setLoader] = useState(true);
  const [allOffers, setAllOffer] = useState([]);
  const [lastPage, setLastPage] = useState(1);
  const [active, setActive] = useState(1);
  const [allId, setAllId] = useState([]);
  const [offerDetail, setOfferDetail] = useState({});
  const [openDetail, setOpenDetail] = useState(false);
  const [delLoader, setDelLoader] = useState(false);
  const [delIndx, setDelIndx] = useState(-1);
  const { handleLogout } = useLogoutHelper();

  const getDonor = () => {
    let query = `${searchText ? "?search=" + searchText : ""} `;
    listAllOffer(query)
      .then(({ data } = data) => {
        setLoader(false);

        setLastPage(data?.total);
        setAllOffer(data.offers);
      })
      .catch((err) => {
        toastMessage(err?.message, "error");
        setLoader(false);
        if (err?.response?.status == 401) {
          handleLogout();
        }
      });
  };
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const changCheckBox = (boxId) => {
    let cloneId = [...allId];
    let checkIndx = allId.findIndex((ii) => ii == boxId?._id);
    if (checkIndx > -1) {
      cloneId.splice(checkIndx, 1);
      setAllId(cloneId);
    } else {
      cloneId.push(boxId?._id);
      setAllId(cloneId);
    }
  };
  // useEffect(() => {
  //   getDonor();
  // }, [active]);
  const selectAll = () => {
    if (allId.length < 1) {
      let allids = allOffers.map((ii) => ii._id);
      setAllId(allids);
    } else {
      setAllId([]);
    }
  };
  const handleClickOpenDetail = (user) => {
    setOpenDetail(true);
    setOfferDetail(user);
  };

  const handleCloseDetail = () => {
    setOpenDetail(false);
  };
  const handleDelete = (type, ids) => {
    let cloneAllOffer = [...allOffers];

    if (type == types.single) {
      setDelLoader(true);

      deleteOffer(ids)
        .then(({ data: { message } }) => {
          let checkIndx = cloneAllOffer.findIndex((ii) => ii?._id == ids);
          if (checkIndx > -1) {
            cloneAllOffer.splice(checkIndx, 1);
            setAllOffer(cloneAllOffer);
          }
          toastMessage(message, "success");
          //remove select id from state
          if (allId?.length) {
            let cloneAllIds = [...allId];
            let checkIdIndx = cloneAllIds.findIndex((ii) => ii == ids);
            if (checkIdIndx > -1) {
              cloneAllIds.splice(checkIdIndx, 1);
              setAllId(cloneAllIds);
            }
          }
        })
        .catch((err) => {
          toastMessage(err.response.data.message, "error");
        })
        .finally(() => setDelLoader(false));
    } else {
      setDelLoader(true);
      deleteOffer(allId?.toString())
        .then(({ data: { message } }) => {
          for (let index = 0; index < allId.length; index++) {
            const element = allId[index];
            let checkIndx = cloneAllOffer.findIndex((ii) => ii?._id == element);
            if (checkIndx > -1) {
              cloneAllOffer.splice(checkIndx, 1);
            }
          }
          setAllId([]);
          setAllOffer(cloneAllOffer);

          toastMessage(message, "success");
        })
        .catch((err) => {
          toastMessage(err.response.data.message, "error");
        })
        .finally(() => setDelLoader(false));
    }
  };
  useDebounce(
    () => {
      setLoader(true);
      getDonor();
    },
    [searchText],
    800
  );

  const renderCompactOfferActions = (row, index) => (
    <>
      <Button
        size="small"
        variant="outlined"
        startIcon={<Visibility />}
        onClick={() => handleClickOpenDetail(row)}
      >
        Details
      </Button>
      <Button
        size="small"
        variant="outlined"
        startIcon={<ModeEdit />}
        onClick={() => {
          navigate("/createOffer", {
            state: {
              offer: row,
              isEdit: true,
            },
          });
        }}
      >
        Edit
      </Button>
      <Button
        size="small"
        color="error"
        variant="outlined"
        startIcon={<Delete />}
        onClick={() => {
          setDelIndx(index);
          handleDelete(types.single, row?._id);
        }}
      >
        Delete
      </Button>
    </>
  );

  return (
    <>
      <div className="flex spaceBetween itemCenter">
        <Typography
          sx={{
            fontStyle: "normal",
            fontWeight: 600,
            fontSize: 32,
            lineHeight: "48px",
            letterSpacing: "-0.5px",
            color: "#11142D",
            marginBottom: "2%",
          }}
        >
          All Offers
        </Typography>
        <div>
          {allId.length > 1 ? (
            <Button
              sx={{
                background: " rgba(255, 183, 190, 0.9);",
                color: "red",
                marginRight: "10px",
              }}
              onClick={() => handleDelete(types.multiple)}
            >
              <Delete style={{ color: "red" }} />
              Delete
            </Button>
          ) : (
            ""
          )}

          <Button variant="outlined" onClick={() => navigate("/createOffer")}>
            <Add />
            Offer
          </Button>
        </div>
      </div>

      <TextField
        id="outlined-basic"
        variant="outlined"
        InputProps={{
          style: {
            borderRadius: "12px",
            border: "none",
            backgroundColor: "#F8F8F9",
            height: "56px",
          },
          autoComplete: "off",
        }}
        sx={{ width: "100%" }}
        placeholder="Search"
        onChange={(e) => setSearchText(e.target.value)}
        value={searchText}
        autoComplete="off"
      />
      {loader ? (
        <div
          style={{ display: "flex", justifyContent: "center", marginTop: "5%" }}
        >
          <Loader />
        </div>
      ) : (
        <>
          {allOffers?.length > 0 ? (
            <>
              {isCompactLayout ? (
                <>
                  <Box
                    sx={{
                      mt: 1.5,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      flexWrap: "wrap",
                      gap: 1,
                    }}
                  >
                    <Typography sx={{ color: "#808191", fontSize: "0.875rem" }}>
                      Selected on page: {allId.length}
                    </Typography>
                    <Button size="small" onClick={selectAll}>
                      {allId.length === allOffers.length ? "Clear selection" : "Select all"}
                    </Button>
                  </Box>
                  <Stack spacing={2} sx={{ mt: 2 }}>
                    {allOffers?.map((row, index) => (
                      <ResponsiveEntityCard
                        key={row?._id || index}
                        selectionControl={
                          <Checkbox
                            {...label}
                            checked={allId.includes(row?._id)}
                            size="small"
                            onChange={() => changCheckBox(row)}
                          />
                        }
                        media={
                          <Box
                            component="img"
                            src={row?.imageURL_mobile ? row?.imageURL_mobile : Sample}
                            alt={row?.title || "Offer"}
                            sx={{
                              width: 56,
                              height: 56,
                              objectFit: "cover",
                              borderRadius: "10px",
                            }}
                          />
                        }
                        title={row?.title}
                        subtitle={(row?.discountPercentage || 0) + "% discount"}
                        fields={[
                          {
                            label: "Click Action",
                            value: row?.ctaValue ? (
                              <Stack
                                direction="row"
                                spacing={1}
                                sx={{ flexWrap: "wrap", alignItems: "center" }}
                              >
                                <span>{row?.ctaKind}</span>
                                <Button
                                  size="small"
                                  variant="text"
                                  onClick={() => window.open(row?.ctaValue, "_blank")}
                                  sx={{ minWidth: 0, px: 0, textTransform: "none" }}
                                >
                                  Open
                                </Button>
                              </Stack>
                            ) : (
                              row?.ctaKind || "--"
                            ),
                          },
                          {
                            label: "Offer Details",
                            value: row?.description,
                            fullWidth: true,
                          },
                        ]}
                        actions={renderCompactOfferActions(row, index)}
                      />
                    ))}
                  </Stack>
                </>
              ) : (
                <TableContainer
                  className="tabledContainer"
                  sx={{
                    marginTop: "2%",
                  }}
                >
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>
                          <Checkbox
                            checked={allId.length ? true : false}
                            onChange={() => selectAll()}
                            {...label}
                            size="small"
                          />
                        </TableCell>
                        <TableCell>Offer</TableCell>
                        <TableCell>Click Action</TableCell>
                        <TableCell>Offer Discount</TableCell>
                        <TableCell>Offer details</TableCell>
                        <TableCell>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {allOffers?.map((row, index) => (
                        <>
                          <TableRow key={index}>
                            <TableCell>
                              <Checkbox
                                {...label}
                                checked={allId.includes(row?._id)}
                                size="small"
                                onChange={() => changCheckBox(row)}
                              />
                            </TableCell>
                            <TableCell>
                              <div className="tableNameDiv">
                                <img
                                  src={row?.imageURL_mobile ? row?.imageURL_mobile : Sample}
                                  height="50"
                                  width="50"
                                  style={{ borderRadius: "6%" }}
                                />
                                <div style={{ marginLeft: "10%" }}>
                                  <div className="taleName">{row?.title}</div>
                                </div>
                              </div>
                            </TableCell>

                            <TableCell>
                              <div>
                                <span>open</span>
                                <a
                                  style={{ marginLeft: "10px" }}
                                  target={"_blank"}
                                  rel="noreferrer"
                                  href={row?.ctaValue}
                                >
                                  {row?.ctaKind}
                                </a>
                              </div>
                            </TableCell>
                            <TableCell>{row?.discountPercentage + "%"}</TableCell>
                            <TableCell>{row?.description}</TableCell>
                            <TableCell>
                              <div style={{ display: "flex" }}>
                                <Button
                                  variant="outlined"
                                  sx={{
                                    minWidth: "45px",
                                    width:"35px",
                                    height: "40px",
                                    borderColor: "#c8bcbc !important",
                                    "&:hover": {
                                      background: "#FEE8CE",
                                    },
                                  }}
                                  onClick={() => handleClickOpenDetail(row)}
                                >
                                  <Visibility style={{ color: "#FD8A25" }} />
                                </Button>
                                <Button
                                  variant="outlined"
                                  sx={{
                                    marginLeft: "5%",
                                    marginRight: "5%",
                                    minWidth: "45px",
                                    width:"35px",
                                    height: "40px",
                                  }}
                                  onClick={() => {
                                    navigate("/createOffer", {
                                      state: {
                                        offer: row,
                                        isEdit: true,
                                      },
                                    });
                                  }}
                                >
                                  <ModeEdit />
                                </Button>
                                <Button
                                  variant="outlined"
                                  sx={{
                                    minWidth: "45px",
                                    width:"35px",
                                    height: "40px",
                                    borderColor:
                                      "rgba(255, 183, 190, 0.9) !important",
                                    "&:hover": {
                                      background: " rgba(255, 183, 190, 0.9);",
                                    },
                                  }}
                                  onClick={() => {
                                    setDelIndx(index);
                                    handleDelete(types.single, row?._id);
                                  }}
                                >
                                  {delLoader && index == delIndx ? (
                                    <Loader colors={"red"} />
                                  ) : (
                                    <Delete style={{ color: "red" }} />
                                  )}
                                </Button>
                              </div>
                            </TableCell>
                          </TableRow>
                        </>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
              {/* <Pagination
                lastPage={lastPage}
                active={active}
                setActive={setActive}
              /> */}
            </>
          ) : (
            <div className="flexCard" style={{ marginTop: "10%" }}>
              <img src={NoData} />
            </div>
          )}
        </>
      )}
      <ViewDetail
        setDetail={setOfferDetail}
        detail={offerDetail}
        open={openDetail}
        handleClose={handleCloseDetail}
      />
    </>
  );
}
